import React, { FC } from 'react'

interface Props {
  className?: string
}
const Twitter: FC<Props> = (props) => {
  return (
    <svg data-name="Layer 1" viewBox="0 0 41.67 41.67" {...props}>
      <path
        d="M34.14 0H7.52A7.52 7.52 0 000 7.52v26.62a7.53 7.53 0 007.52 7.53h26.62a7.53 7.53 0 007.53-7.53V7.52A7.53 7.53 0 0034.14 0zm-2.95 15.52v.69A15.19 15.19 0 017.82 29c.42 0 .84.07 1.27.07a10.68 10.68 0 006.64-2.29 5.34 5.34 0 01-5-3.71 5.21 5.21 0 002.42-.07 5.35 5.35 0 01-4.29-5.24.2.2 0 010-.07 5.22 5.22 0 002.42.67 5.35 5.35 0 01-1.66-7.13 15.17 15.17 0 0011 5.58 5.43 5.43 0 01-.13-1.22 5.34 5.34 0 019.24-3.65 10.7 10.7 0 003.39-1.3 5.33 5.33 0 01-2.35 3 10.9 10.9 0 003.07-.84 10.62 10.62 0 01-2.65 2.72z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Twitter
